import { registerPlugin } from '@capacitor/core';

import type { WechatHKPlugin } from './definitions';

const WechatHK = registerPlugin<WechatHKPlugin>('WechatHK', {
  web: () => import('./web').then(m => new m.WechatHKWeb()),
});

export * from './definitions';
export { WechatHK };
